/**
 * RealCampaignConfigService - Real implementation for production use
 *
 * Fetches campaign configs from the realtime-api HTTP endpoint.
 */

import type { HostCampaignConfig } from '@playcastdotio/Messaging';
import type { ICampaignConfigService } from './ICampaignConfigService';
import constants from '@playcastdotio/GlobalConfig';

export class RealCampaignConfigService implements ICampaignConfigService {
  async fetchConfig(campaignId: string): Promise<HostCampaignConfig | null> {
    try {
      console.log(`[CampaignConfigService] Fetching config for campaign: ${campaignId}`);

      const baseUrl = constants.REALTIME_API_BASE_URL.replace(/\/$/, ''); // Remove trailing slash
      const apiUrl = `${baseUrl}/realtime/campaigns/${campaignId}/host-config`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`Failed to fetch campaign config: ${response.statusText}`);
      }

      const rawData = await response.json();

      if (!rawData.success || !rawData.campaign) {
        throw new Error(rawData.error || 'Campaign not found in response');
      }

      const config = rawData.campaign as HostCampaignConfig;
      console.log(`[CampaignConfigService] ✅ Fetched config for "${config.displayName}":`, {
        campaignId: config.campaignId,
        displayName: config.displayName,
        onLaunchMacro: config.onLaunchMacro?.length || 0,
        onJoinMacro: config.onJoinMacro?.length || 0,
        launchPackage: config.launchPackage,
      });

      return config;
    } catch (error) {
      console.error(`[CampaignConfigService] ❌ Failed to fetch campaign config for "${campaignId}":`, error);
      return null;
    }
  }
}
